var map = {
	"./arrowdown.svg": "vQ9a",
	"./check.svg": "7UNq",
	"./list.svg": "dBND",
	"./map.svg": "t+bR",
	"./person.svg": "YBb2",
	"./phone.svg": "s105",
	"./selection-copy-8.svg": "F186",
	"./service-legend.svg": "ETcG",
	"./sort.svg": "ebhS",
	"./time.svg": "Wo16",
	"./trash.svg": "IhQk",
	"./type.svg": "Xira",
	"./type2.svg": "7Kym",
	"./write.svg": "bNhb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4GJc";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img nonrecursive ./node_modules/raw-loader!./node_modules/svgo-loader?{"plugins":[{"removeTitle":true}]} \.svg$
// module id = 4GJc
// module chunks = 1